// JavaScript code for acf_blocks/tabbed-content-with-background component
(($) => {

     "use strict";
     console.log("acf_blocks/tabbed-content-with-background scripts loaded...");

})(jQuery);